const func = $target => {
    var $inputs = $target.find('input[data-address-input="contact"]'),
        $checkbox = $target.find('input[type="checkbox"]'),
        $country = $target.find('#country'),
        $taxIdOptionalLabel = $target.find('label[for="businessTaxId"] .text-muted'),
        $taxId = $target.find('#businessTaxId');

    $inputs.each(function() {
        var $this = $(this);
        $this.data('value', $this.val());
    });

    $checkbox.on('change', function(e) {
        if ($checkbox.prop('checked')) {
            $inputs
                .each(function() {
                    var $el = $(this);
                    $el.val($el.data('value'));
                })
                .prop('readonly', true);
        } else {
            $inputs.prop('readonly', false).val('');
        }
    }).trigger('change');

    $country.on('change', function(e) {
        if($(this).val() == '68') {
            $taxId.prop('required',true);
            $taxId.prop('pattern','.{9,}');
            $taxIdOptionalLabel.addClass('d-none');
            $taxId.parent().find('.invalid-feedback').text('Please enter a valid Tax ID/VAT Number code (minimum 9 characters).');
        } else {
            $taxId.prop('required',false);        
            $taxId.removeAttr('pattern');
            if($taxIdOptionalLabel.hasClass('d-none')) {
                $taxIdOptionalLabel.removeClass('d-none');
            }
        }
    });
};

export default func;